<div class="layout-col full bg-background">
  <mat-toolbar elderTheme class="layout-row place-start-center gap-sm">
    <button mat-icon-button matDialogClose>
      <mat-icon>close</mat-icon>
    </button>

    <elder-header
      header="{{ 'positions.position' | translate }} {{ item.number }}"
      subheader="{{ item.workOrderId }} / {{ item.id }}"
    >
    </elder-header>
  </mat-toolbar>

  <app-terminal-work-item-detail
    class="flex"
    [workItem]="item"
    [controlTerminal]="controlTerminal"
    [workCenterId]="workCenterId"
    [printingEnabled]="printingEnabled"
  >
  </app-terminal-work-item-detail>
</div>
